import { QueryClient } from '@tanstack/react-query';
import { getApiErrorStatus } from './client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // 4xx answers (bad filter, not found, forbidden) will not change on retry.
      retry: (failureCount, error) => {
        const status = getApiErrorStatus(error);
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
    },
  },
});
